// --------------------- Import Globais ---------------------
import { useEffect, useRef, useState } from "react";
import { NumberParam, useQueryParams } from "use-query-params";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------

import {
  Col,
  Flex,
  Row,
  MenuProps,
  Skeleton,
  Table,
  Typography,
  Button,
} from "antd";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";

// --------------------- Import Styles ---------------------
import { Container } from "./styles";

// --------------------- Import Hooks ---------------------
import { useError } from "../../uteis/mensagens/useError";
import { useSuccess } from "../../uteis/mensagens/useSuccess";
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useReservas } from "./hooks/useReservas";
import { useReservaPeriodo } from "./hooks/useReservaPeriodo";
import { useReservaSemPeriodo } from "./hooks/useReservaSemPeriodo";
import { useAtualizarReservaPeriodo } from "./hooks/useAtualizarReservaPeriodo";

// --------------------- Import Constants ---------------------
// import { items } from "./constants/itemsActionColumns";

// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
import ModalHospedes from "./components/ModalHospedes";

import { useMediaQuery } from "@mui/material";
import ModalAdicionar from "./components/ModalAdicionar";

// ---------------------  ---------------------

export default function ViewGerenciarReserva() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Realiza a busca das reservas cadastradas

  const { reservas, isLoading: isReservasLoading } = useReservas();
  // Verificação de permissão do usuário, NDA = 0 - SEM PERMISSÃO, NDA = 1 - COM PERMISSÃO

  // Definação do Loading caso seja permitido
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // Controle de Paginação
  const currentPage = useRef(1);

  // Armazena o valor da reserva selecionada
  const [reservaId, setReservaId] = useState<number | null>(null);

  // State de abertura e fechamento do modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Funçao para abrir o modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  // State de abertura e fechamento do modal (Adicionar Lead)
  const [isModalAdicionarOpen, setIsModalAdicionarOpen] = useState(false);

  // Funçao para abrir o modal (Adicionar Apartamento)
  const adicionarModal = () => {
    setIsModalAdicionarOpen(true);
  };

  // Funçao para fechar o modal (Editar Adicionar)
  const handleAdicionarFechar = () => {
    setIsModalAdicionarOpen(false);
  };
  // const columns = Columns(items || [], onClick, setReservaId);

  const [queryParams] = useQueryParams({
    periodoUsuarioId: NumberParam,
  });
  const periodoUsuarioId = queryParams.periodoUsuarioId;

  const { reservaPeriodo } = useReservaPeriodo(periodoUsuarioId);

  const { reservaSemPeriodo } = useReservaSemPeriodo();

  const [idAtualizar, setIdAtualizar] = useState<number | null>(null);
  // Use o hook apenas se idAtualizar estiver definidos

  const { success, error, resetError, atualizar, isLoading } =
    useAtualizarReservaPeriodo();

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Ver hospedes
      case "1":
        showModal();
        break;
      // Vincular Período a reserva
      case "2":
        atualizar(reservaId, periodoUsuarioId);

        break;

      default:
        showError("Em desenvolvimento!");
        break;
    }
  };

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa estado de sucesso após 3 segundos e recarrega a página
      setTimeout(() => {
        setSuccessDisplayed(false);
        window.location.reload();
      }, 3000);
    }
    // Exibe a mensagem de erro
    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa estado de error após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    success,
    error,
    showSuccess,
    showError,
    errorDisplayed,
    successDisplayed,
    resetError,
  ]);

  // Traz os items das colunas (ReservaId, Reserva OTA e Data Reserva) e traz o id da reserva selecionada
  const columns = Columns(
    reservaPeriodo,
    reservaSemPeriodo,
    periodoUsuarioId,
    onClick,
    setReservaId
  );

  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();

  // ---------------------  ---------------------
  return (
    <>
      {isTokenLoading || !isValid || isReservasLoading ? (
        <Skeleton active />
      ) : !periodoUsuarioId ? (
        <Container>
          <>{errorContextHolder}</>
          <>{successContextHolder}</>

          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <ArrowBackIcon
                  color="primary"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(-1)}
                />
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />

                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Reservas Cadastradas
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <Col span={1}></Col>
            <Col span={22} style={{ marginTop: 20, marginBottom: 50 }}>
              <Flex
                align="start"
                justify="center"
                style={{ width: "100%", overflow: "auto" }}
              >
                <Table
                  columns={columns}
                  dataSource={reservas}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage.current }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
          <ModalHospedes
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            reservaId={reservaId}
          />
        </Container>
      ) : (
        <Container>
          {/* Feedback de erro e sucesso */}
          {errorContextHolder}
          {successContextHolder}

          {/* Cabeçalho */}
          <Row align="middle" justify="center">
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <ArrowBackIcon
                  color="primary"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(-1)}
                />
              </Flex>
            </Col>

            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />
                <Title
                  level={3}
                  style={{
                    marginTop: isMobile ? 10 : "",
                    marginLeft: 10,
                    color: "rgb(0, 54, 68)",
                  }}
                >
                  {reservaPeriodo.length > 0
                    ? "Reserva do Período"
                    : "Reservas sem Período"}
                </Title>
              </Flex>
            </Col>

            <Col span={7} style={{ textAlign: "right", paddingRight: 20 }}>
              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: isMobile ? 0 : "0px",
                }}
                onClick={adicionarModal}
                type="primary"
              >
                + Reserva
              </Button>
            </Col>
          </Row>

          {/* Tabela de Reservas */}
          <Row justify="center" style={{ marginTop: 40, marginBottom: 50 }}>
            <Col span={22}>
              <Table
                columns={columns}
                dataSource={
                  reservaPeriodo.length > 0 ? reservaPeriodo : reservaSemPeriodo
                }
                bordered
                style={{ width: "100%" }}
                pagination={{ defaultCurrent: currentPage.current }}
              />
            </Col>
          </Row>

          {/* Modais */}
          <ModalHospedes
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            reservaId={reservaId}
          />
          <ModalAdicionar
            isModalOpen={isModalAdicionarOpen}
            handleFechar={handleAdicionarFechar}
          />
        </Container>
      )}
    </>
  );
}
